import { notification } from 'antd';
import { call, debounce, put } from 'redux-saga/effects';

import { DEFAULT_DEBOUNCE_DELAY } from '#constants';
import TraderService from '#services/TraderService';

import { getTraders, setLoading, setTraders } from './';

function* getTradersList(data) {
  try {
    yield put(setLoading(true));
    const agents = yield call(TraderService.getList, data?.payload);
    yield put(setTraders(agents));
  } catch (error) {
    notification.error({ message: error?.response?.data?.error?.message });
    yield put(setTraders({ count: 0, result: [] }));
    yield put(setLoading(false));
  }
}

function* TradersSaga() {
  yield debounce(DEFAULT_DEBOUNCE_DELAY, getTraders.type, getTradersList);
}

export default TradersSaga;
